// extracted by mini-css-extract-plugin
export default {"npGreen":"#215830","npDarkGreenGray":"#2f4f4f","npRed":"#c90000","npBlue":"#000f4d","active":"#555"};